import React from "react";
import "./footer.css";
import whatsapp from '../../assests/images/icons8-whatsapp (1) 1.svg';
import location from '../../assests/images/location_on.svg';
import call from '../../assests/images/call.svg';
import email from '../../assests/images/email.svg';


const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-section">
                    <h2 className="footer-heading">Seventh August IT Services Private Ltd.</h2>
                    <p className="footer-text">
                        Seventh August IT Services Private Ltd. is a wholly owned subsidiary of Nihilent Ltd. (
                        <a href="https://www.nihilent.com" target="_blank" rel="noopener noreferrer">
                            www.nihilent.com
                        </a>
                        ), a global IT Consulting and Solutions company.
                    </p>
                </div>

                <div className="footer-section">
                    <h2 className="footer-heading">Get in Touch</h2>
                    <p className="footer-address">
                        <img
                            src={location}
                            alt="Location"
                        />
                        4th floor, 'D' Block, Weikfield IT Citi Info Park, Nagar Road, Sakore Nagar, Viman Nagar, Pune, Maharashtra 411014
                    </p>
                    <div className="contact-container">
                        <p className="footer-contact">
                            <img src={email} alt="Email" />
                            <a href="mailto:hello@artoreal.com">hello@artoreal.com</a>
                        </p>
                        <p className="footer-contact">
                            <img src={call} alt="Call us " />
                            +918840929083
                        </p>
                        <p className="footer-contact">
                            <img src={whatsapp} alt="Whatsapp" />
                            +919956528858
                        </p>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <hr />
                <p>© 2024 Seventh August IT Services Private Limited. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
